/** @file Viewport overlay toggles -> OverlayOptions (grid from the document grid, onion only when animating). */
import type { ViewDoc } from '@pose2d/format/types';
import { gridSpecFromView } from '@pose2d/overlay/gridSpecFromView';
import type { OverlayOptions } from '@pose2d/overlay/types';

/** The toolbar's on/off layers (session state in viewportStore, not in the document). */
export interface OverlayToggles { bones: boolean; names: boolean; mesh: boolean; ik: boolean; sockets: boolean; axes: boolean; grid: boolean; onion: boolean }

/** `selection` holds data indices; the grid (and its footprint) follows `view.grid` when the toggle is on. */
export function overlayOptionsFor(t: OverlayToggles, grid: ViewDoc['grid'], selection: { bones: number[]; slots: number[] }, animating: boolean): OverlayOptions {
  const spec = t.grid ? gridSpecFromView(grid) : null;
  return {
    bones: t.bones, boneNames: t.names, mesh: t.mesh, ik: t.ik, sockets: t.sockets, axes: t.axes,
    ...(spec === null ? {} : { grid: spec }),
    ...(t.onion && animating ? { onion: { before: 2, after: 2, step: 1 } } : {}),
    selection,
  };
}
